<template>
  <HeraDummyList :icon-name="dummyOptions.icon" size="200" position="center">
    {{ dummyOptions.label }}
  </HeraDummyList>
</template>

<script>
import HeraDummyList from '@/components/common/HeraDummyList';
import { mapState } from 'vuex';
import { CLAN } from '@/constants/accounts';

export default {
  name: 'AccountDeleted',
  components: {
    HeraDummyList,
  },
  computed: {
    ...mapState('current', ['account', 'accountType']),
    dummyOptions() {
      if (this.accountType === CLAN) {
        return {
          icon: 'deleted-clan',
          label: this.$t(
            '_web_teams_clan-deleted',
            `Team {name} doesn't exist`,
            { name: this.account.name }
          ),
        };
      } else {
        //placeholder if we got deleted account with another type !== 'clan'
        return {
          icon: 'trash',
          label: '',
        };
      }
    },
  },
};
</script>
